import { Box } from "@mui/material";
import React, { useMemo } from "react";
import SimpleMdeReact from "react-simplemde-editor";
import "easymde/dist/easymde.min.css";

const CustomMde = ({
  label = "",
  required = false,
  error = "",
  onChange,
  value,
  placeholder=''
}) => {
  const mdeOptions = useMemo(() => {
    return {
      minHeight: "120px", // Approximately 3 rows height
      maxHeight: "120px",
      spellChecker: false,
      status: false, // Hide status bar to save space
      toolbar: [
        "bold",
        "italic",
        "heading",
        "|",
        "unordered-list",
        "ordered-list",
        "|",
        "link",
        "preview",
        "fullscreen",
        "|",
        "undo",
        "redo",
        "guide",
      ], // Minimal toolbar
    //   toolbarTips: true,
    };
  }, []);
  return (
    <Box
      sx={{
        "& .EasyMDEContainer": {
          border: error ? "1px solid red" : "1px solid #ccc",
        },
        "& .editor-toolbar": {
          borderBottom: "1px solid #ccc",
        },
        // '& .CodeMirror': {
        //   minHeight: '120px',
        //   maxHeight: '120px',
        //   overflow: 'auto !important'
        // }
      }}
    >
      <label className="block text-sm font-semibold text-gray-700 mb-1">
        {label}&nbsp;{required && <span className="text-red-500">*</span>}
      </label>
      <SimpleMdeReact value={value} onChange={onChange} options={mdeOptions} placeholder={placeholder} />
      {error && (
        <Box sx={{ color: "red", fontSize: "0.75rem", mt: 0.5 }}>
          {error}
        </Box>
      )}
    </Box>
  );
};

export default CustomMde;
